import { createContext } from 'react';

const LayoutContext = createContext(null);
LayoutContext.displayName = 'Layout';

export default LayoutContext;
